<template>
    <div class="content">
        <section class="hero" id="home">
        <div class="container">
          <div class="hero-content">
            <p class="hero-subtitle">Quebramos o Comum. Criamos Resultados </p>

            <h2 class="h2 hero-title">Estratégia Que Conecta
Pessoas
Gera Resultados</h2>

            <p class="hero-text">
            Criamos soluções estratégicas que aproximam marcas de pessoas, aceleram receitas e constroem conexões que realmente importam.
            </p>

          <!---->  <button class="btn">Learn More</button>
          </div>
          <!--   #src="https://raw.githubusercontent.com/codewithsadee/desinic/master/assets/images/hero-banner.png"-->
          <figure class="hero-banner" style="margin-left: 10%;">
          <!-- 
            <video
           :src="require('@/assets/img/animacao.mp4')"
              width="100%"
              height="800"
        
              alt="hero-banner"
              class="w-100 banner-animation"
              autoplay
              loop
              muted
            />
          -->
 
            <img 
            :src="require('@/assets/img/logomov.gif')"
              width="100%"
              height="800"
              >
              
          </figure>
        </div>
      </section>

      <!-- 
        - #ABOUT
      -->
<!--
      <section class="section about" id="about">
        <div class="container">
          <figure class="about-banner">
            <img
              src="https://github.com/codewithsadee/desinic/blob/master/assets/images/about-banner.png?raw=true"
              width="700"
              height="532"
              loading="lazy"
              alt="about banner"
              class="w-100 banner-animation"
            />
          </figure>

          <div class="about-content">
            <h2 class="h2 section-title underline">Why Our Agency</h2>

            <p class="about-text">
              In dictum aliquam turpis lacinia iaculis. Fusce vel malesuada
              magna. Nulla vel maximus risus. Donec volutpat metus lacinia risus
              accumsan, ac bibendum libero efficitur. Pellentesque nec nisi sit
              amet magna tempus hendrerit ut a odio.
            </p>

            <p class="about-text">
              Praesent rhoncus commodo tortor, id pulvinar nisl blandit at.
              Nulla facilisi. Quisque turpis ante, vehicula condimentum arcu.
            </p>

            <ul class="stats-list">
              <li class="stats-card">
                <p class="h3 stats-title">9875</p>

                <p class="stats-text">Satisfied Clients</p>
              </li>

              <li class="stats-card">
                <p class="h3 stats-title">789</p>

                <p class="stats-text">Project Lunched</p>
              </li>

              <li class="stats-card">
                <p class="h3 stats-title">65</p>

                <p class="stats-text">Years Completed</p>
              </li>
            </ul>
          </div>
     
        </div>
      </section>
         -->
    </div>
</template>


<style scoped>
    
/*-----------------------------------*\
  #HERO
\*-----------------------------------*/

.hero {
  background-image: url("https://raw.githubusercontent.com/codewithsadee/desinic/master/assets/images/hero-bg-bottom.png"),
    url("https://raw.githubusercontent.com/codewithsadee/desinic/master/assets/images/hero-bg.png"), var(--gradient-1);
  background-repeat: no-repeat, no-repeat, no-repeat;
  background-position: -280px bottom, center, center;
  background-size: cover, cover, auto;
  padding-block-start: 120px;
  padding-block-end: var(--section-padding);
}

.hero-content {
  margin-block-end: 50px;
}

.hero-subtitle {
  color: var(--chrome-yellow);
  font-family: var(--ff-source-sans-pro);
  font-size: var(--fs-7);
  margin-block-end: 15px;
}

.hero-title {
  color: var(--white);
  font-size: var(--fs-1);
  margin-block-end: 20px;
}

.hero-text {
  color: var(--white);
  font-size: var(--fs-8);
  margin-block-end: 30px;
  text-align: justify;
}


/* Celulares pequenos */
@media (max-width: 480px) {

figure{
  width:80%;
}
}
/* Celulares médios */
@media (max-width: 767px) {

figure{
  width:80%;

}

  }
</style>